<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss">
@import "assets/scss/variables";

@font-face {
  font-family: "sfRegular";
  src: url("/static/fonts/sfRegular.otf") format("truetype");
}

html {
  font-size: 100px;
  @media screen and (max-width: 374px) {
    font-size: 85.33px;
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

body {
  font-family: "sfRegular", Arial, Heiti, "黑体", sans-serif;
  background: #fff;
  padding-right: 0 !important;
}

a,
a:hover,
a:active,
a:link {
  text-decoration: none;
}

button {
  outline: none;
}
input::-webkit-contacts-auto-fill-button {
  visibility: hidden;
  display: none !important;
  pointer-events: none;
}
input::-ms-clear {
  display: none;
}
input::-ms-reveal {
  display: none;
}
.grecaptcha-badge {
  display: none !important;
}
</style>

<script>
import { Validator } from "vee-validate";

export default {
  name: "app-view",
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    queryLang() {
      return this.$route.query.lang;
    },
    paymentLanguage() {
      if (!this.$route.query.language) return;
      let queryLanguage = this.$route.query.language;
      if (queryLanguage.toLowerCase().indexOf("zh") > -1) {
        queryLanguage = "zh";
      }
      if (
        queryLanguage &&
        queryLanguage === window.localStorage.getItem("paymentLang")
      ) {
        window.localStorage.removeItem("paymentLang");
        return queryLanguage;
      }
    },
  },
  mounted() {
    if (window.navigator.appVersion.indexOf("iPhone") > -1) {
      document.getElementsByTagName("meta")["viewport"].content =
        "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0";
    }
  },
  created() {
    if (this.$route.query["qr_token"]) {
      window.sessionStorage.setItem("qr_token", this.$route.query["qr_token"]);
    }
    this.initLang();
    if (this.$route.path.indexOf("/app/") !== -1) return;
    if (process.env.NODE_ENV === "development") return;
    this.$http.get("api/checkIp").then((response) => {
      if (response.data.code === 0) {
        this.$store.commit("setPauseServeInfo", response.data.data);
        this.$router.replace("/pause-serve");
      }
    });
  },
  methods: {
    initLang() {
      if (this.queryLang === "zh" || this.queryLang === "en") {
        this.$store.commit("setCurrentLang", this.queryLang);
        Validator.setLocale(currentLang);
      }
      if (this.$route.query.from === "client") return;
      let currentLang;
      if (this.paymentLanguage) {
        currentLang = this.paymentLanguage;
      } else if (window.localStorage.getItem("currentLang")) {
        currentLang = window.localStorage.getItem("currentLang");
      } else {
        currentLang = window.navigator.language || navigator.browserLanguage;
        currentLang = currentLang.substring(2, currentLang).toLowerCase();
        if (currentLang !== "zh") {
          currentLang = "en";
        }
      }
      this.$store.commit("setCurrentLang", currentLang);
      Validator.setLocale(currentLang);
    },
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?76fbef0e